import React, { PropTypes } from 'react';
import cn from 'classnames';

import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { getNextFocusableElement } from '@bibliocommons/utils-accessibility';
import { childrenShape } from '@bibliocommons/bc-prop-types';

export default class DisplayWrapper extends BcReactComponent {
  constructor(props) {
    super(props);

    this.displayRef = null;
  }

  componentWillUnmount() {
    // If this Display component has focus, then move focus to the next focusable element on the page once it's removed.
    if (this.displayRef && document.activeElement && this.displayRef.contains(document.activeElement)) {
      const nextFocusableElement = getNextFocusableElement(this.displayRef);
      if (nextFocusableElement) {
        nextFocusableElement.focus();
      }
    }
  }

  render() {
    return (
      <div
        className={cn('cp-ugc-display', this.props.className)}
        ref={(el) => { this.displayRef = el; }}>
        {this.props.children}
      </div>
    );
  }
}

DisplayWrapper.propTypes = {
  className: PropTypes.string,
  children: childrenShape.isRequired
};



// WEBPACK FOOTER //
// ./app/components/shared/UGC/DisplayWrapper/DisplayWrapper.jsx